export default __webpack_public_path__ + "static/media/FabSystemsLogo.a6362d82.png";